import React, { useState, useEffect } from 'react';
import baseURL from "../component/baseURL";
import { useNavigate } from 'react-router-dom';
import stringsoflanguages from '../component/stringsoflanguages';

export default function BlockedMembers({ isMobile }) {
    const [blockedMembers, setBlockedMembers] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const searchLower = (searchQuery || '').trim().toLowerCase();
    const filteredMembers = searchLower
        ? blockedMembers.filter((m) => {
            const fname = (m.member_fname ?? '').toLowerCase();
            const lname = (m.member_lname ?? '').toLowerCase();
            const title = (m.title ?? '').toLowerCase();
            const city = (m.city_name ?? '').toLowerCase();
            const country = (m.country_name ?? '').toLowerCase();
            const fullName = `${fname} ${lname}`.trim();
            return fullName.includes(searchLower) || fname.includes(searchLower) || lname.includes(searchLower)
                || title.includes(searchLower) || city.includes(searchLower) || country.includes(searchLower);
        })
        : blockedMembers;

    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        if (userid) fetchBlockedMembersAPI(userid);
        else setLoading(false);
    }, []);

    function fetchBlockedMembersAPI(userid) {
        setLoading(true);
        const formdata = new FormData();
        formdata.append("user_id", userid);
        formdata.append("key", localStorage.getItem('auth_key') || '81dc9bdb52d04dc20036dbd8313ed055');
        fetch(baseURL.URL + '/member/blocked_users', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson.response?.connection_user;
                const ok = responseJson.server?.result_code === 200 || responseJson.server?.code === 200;
                if (ok && Array.isArray(result)) {
                    setBlockedMembers(result);
                } else {
                    setBlockedMembers([]);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setBlockedMembers([]);
                setLoading(false);
            });
    }

    if (loading) {
        return (
            <div className="content-right global-members-page page-loader-wrapper">
                <div className="react-js-loader">
                    <div className="react-js-loader-spinner"></div>
                    <p className="react-js-loader-text">Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="content-right global-members-page">
            <h2 className="section-title blocked-members-heading">{stringsoflanguages.blockedMembers}</h2>

            <div className="search-filter-section">
                <div className="search-bar">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        className="search-icon"
                    >
                        <path
                            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17.5 17.5L13.875 13.875"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <input
                        type="text"
                        placeholder="Search by name / company"
                        className="search-input"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>
                <button type="button" className="filter-btn" aria-label="Filter">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.4062 4.69678C14.5256 4.69678 12.9441 6.04475 12.5793 7.82178H2.34375C1.91228 7.82178 1.5625 8.17156 1.5625 8.60303C1.5625 9.0345 1.91228 9.38428 2.34375 9.38428H12.5793C12.9441 11.1613 14.5256 12.5093 16.4062 12.5093C18.2869 12.5093 19.8684 11.1613 20.2332 9.38428H22.6562C23.0877 9.38428 23.4375 9.0345 23.4375 8.60303C23.4375 8.17156 23.0877 7.82178 22.6562 7.82178H20.2332C19.8684 6.04475 18.2869 4.69678 16.4062 4.69678ZM16.4062 6.25928C17.7099 6.25928 18.75 7.29938 18.75 8.60303C18.75 9.90668 17.7099 10.9468 16.4062 10.9468C15.1026 10.9468 14.0625 9.90668 14.0625 8.60303C14.0625 7.29938 15.1026 6.25928 16.4062 6.25928Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.59375 12.5093C6.71313 12.5093 5.1316 13.8573 4.76685 15.6343H2.34375C1.91228 15.6343 1.5625 15.9841 1.5625 16.4155C1.5625 16.847 1.91228 17.1968 2.34375 17.1968H4.76685C5.1316 18.9738 6.71313 20.3218 8.59375 20.3218C10.4744 20.3218 12.0559 18.9738 12.4207 17.1968H22.6562C23.0877 17.1968 23.4375 16.847 23.4375 16.4155C23.4375 15.9841 23.0877 15.6343 22.6562 15.6343H12.4207C12.0559 13.8573 10.4744 12.5093 8.59375 12.5093ZM8.59375 14.0718C9.8974 14.0718 10.9375 15.1119 10.9375 16.4155C10.9375 17.7192 9.8974 18.7593 8.59375 18.7593C7.2901 18.7593 6.25 17.7192 6.25 16.4155C6.25 15.1119 7.2901 14.0718 8.59375 14.0718Z"
                            fill="white"
                        />
                    </svg>
                </button>
            </div>

            <div className="member-cards-grid">
                {filteredMembers.length === 0 ? (
                    <p className="no-data-message">
                        {searchQuery.trim() ? stringsoflanguages.noBlockedMembersMatchYourSearch : stringsoflanguages.noBlockedMembers}
                    </p>
                ) : (
                    filteredMembers.map((member) => (
                        <div
                            className="member-card cursor-pointer"
                            key={member.user_id ?? member.id ?? Math.random()}
                            onClick={() => {
                                const id = member.user_id ?? member.id;
                                if (!id) return;
                                navigate('/member-profile', {
                                    state: {
                                        memberID: id,
                                        member,
                                        from: '/home/blocked-members',
                                    },
                                });
                            }}
                        >
                            <div className="member-info">
                                <p className="member-since">{stringsoflanguages.memberSince}: {member.added_date ?? '—'}</p>
                                <h3 className="member-name">{member.member_fname} {member.member_lname}</h3>
                                <p className="member-role">{member.title ?? '—'}</p>
                                <p className="member-location">{[member.city_name, member.country_name].filter(Boolean).join(', ') || '—'}</p>
                            </div>
                            <div className="member-image">
                                <img src={member.member_image_thumb ?? member.member_image ?? 'https://placehold.co/80x80'} alt={member.member_fname ?? 'Member'} />
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
